import styled from 'styled-components';
import { InfoBanner } from '@sparknz/spark-pattern-library';

const BaseInfoBanner = styled(InfoBanner)`
  max-width: 550px;
`;

export default BaseInfoBanner;
